import { render, staticRenderFns } from "./news-edit.vue?vue&type=template&id=66986f09&"
import script from "./news-edit.vue?vue&type=script&lang=ts&"
export * from "./news-edit.vue?vue&type=script&lang=ts&"
import style0 from "./news-edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports